import { UiService } from './../../shared/services/ui/ui.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { FaiconService } from './../../shared/services/faicon/faicon.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { RatingService } from 'app/shared/services/rating/rating.service';
import { $ } from 'protractor';
import { SessionForRating } from 'app/shared/models/class/session/session';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {

  selectedRating = 0;
  stars = [
    {
      id: 1,
      icon: 'star',
      class: 'star-gray star-hover star'
    },
    {
      id: 2,
      icon: 'star',
      class: 'star-gray star-hover star'
    },
    {
      id: 3,
      icon: 'star',
      class: 'star-gray star-hover star'
    },
    {
      id: 4,
      icon: 'star',
      class: 'star-gray star-hover star'
    },
    {
      id: 5,
      icon: 'star',
      class: 'star-gray star-hover star'
    }
  ];

  ratingForm: UntypedFormGroup;

  isExpired = false;
  formSent = false;
  isLoading = false;

  token: string;
  bookedSessionKey: string;
  sessionKey: string;

  commentMaxLength = 500;

  session: SessionForRating;
  srcOfferImage: any;

  constructor(
    private faIconService: FaiconService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private ratingsSrv: RatingService,
    private uiSrv: UiService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.checkRouteParams();
    this.initSub();

    // document.getElementById('offerImageCell').style.background = 'url(' + this.srcOfferImage +')';
  }

  private checkRouteParams(): void {
    if (!this.route.snapshot.queryParams.bookedSessionKey) {
      this.isExpired = true;
    }
    this.bookedSessionKey = atob(this.route.snapshot.queryParams.bookedSessionKey);
    this.sessionKey = atob(this.route.snapshot.queryParams.sessionKey);

    if (!this.bookedSessionKey) {
      this.isExpired = true;
    }
  }

  private initSub() {
    this.isLoading = true;
    this.ratingsSrv.getInfosSession(this.sessionKey, this.bookedSessionKey).subscribe(session => {
      this.session = session;
      this.srcOfferImage = this.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${session.picture}`);

      this.initForm();
    })
  }

  private initForm(): void {
    this.ratingForm = this.fb.group({
      comment: ['', [Validators.required, Validators.maxLength(this.commentMaxLength)]]
    });



    this.isLoading = false;
  }

  selectStar(value): void{

      this.stars.filter( (star) => {

        if ( star.id <= value){

          star.class = 'star-gold star star-hover';

        }else{
          star.class = 'star-gray star star-hover';

        }

        return star;
      });


    this.selectedRating = value;

    if (this.selectedRating < 3) {
      this.ratingForm.get('comment').setValidators([Validators.required, Validators.maxLength(this.commentMaxLength)]);
      this.ratingForm.get('comment').updateValueAndValidity();
    } else {
      this.ratingForm.get('comment').clearValidators();
      this.ratingForm.get('comment').setValidators(Validators.maxLength(this.commentMaxLength));
      this.ratingForm.get('comment').updateValueAndValidity();
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  sendRating() {


    let ratingToSend = {
      rating: this.selectedRating,
      comment: this.ratingForm.value.comment,
      bookedSessionKey: this.bookedSessionKey,
      sessionKey: this.sessionKey
    }

    this.ratingsSrv.postRating(ratingToSend).subscribe(() => {
      this.formSent= true;
      this.uiSrv.showSnackbar('Votre évaluation a bien été envoyée, merci.')
    }, (error) => {
      if (error.statusText === 'OK') {
        this.uiSrv.showSnackbar(error.error)
      }
    });
  }

}
